import { Select } from "antd";
import styled from "styled-components";

export const StyledSelect = styled(Select)`
    width: 100%;

    .ant-select-selection-placeholder {
        color: ${({ theme }) => theme.disabledTypographyColor};
    }
`;

export const StyledContainer = styled.div`
    padding: 16px;

    background-color: ${({ theme }) => theme.primaryBackground};
`;
